module.exports = __webpack_public_path__ + "img/grupo-massa.ba808819.png";